// extracted by mini-css-extract-plugin
export default {"dot":"v1VNTwNe4NSCJJf50HPI","green":"sbtkbDReAINmI9s2xKR9","red":"wgWzbzcYqfzfhnkc2HXc"};